import { render, staticRenderFns } from "./EsyArticle.vue?vue&type=template&id=9531a6c6&scoped=true"
import script from "./EsyArticle.vue?vue&type=script&lang=ts"
export * from "./EsyArticle.vue?vue&type=script&lang=ts"
import style0 from "./EsyArticle.vue?vue&type=style&index=0&id=9531a6c6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9531a6c6",
  null
  
)

export default component.exports